import type { SxProps, Theme } from '@mui/material';

export const dialogPaperSx: SxProps<Theme> = {
  width: 400,
  maxWidth: '100%',
  bgcolor: 'background.paper',
  borderRadius: 6,
  border: '1px solid',
  borderColor: 'grey.800',
  m: 2,
};

export const customizeButtonSx: SxProps<Theme> = {
  bgcolor: 'grey.900',
  color: 'common.white',
  boxShadow: 'none',
  '&&:hover': {
    bgcolor: 'grey.800',
    boxShadow: 'none',
  },
};

export const descriptionSx: SxProps<Theme> = {
  color: 'global01.50',
  textAlign: { xs: 'center', md: 'start' },
  display: '-webkit-box',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 4,
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  alignSelf: 'stretch',
};

export const titleSx: SxProps<Theme> = (theme) => ({
  ...theme.typography.h5,
  color: theme.vars.palette.text.primary,
  textAlign: 'center',
  display: 'block',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    ...theme.typography.h6,
    textAlign: 'start',
  },
});
